/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktResponseBaseType
 */
export interface GetAktResponseBaseType {
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseBaseType
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseBaseType
     */
    icon?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseBaseType
     */
    id?: number;
}

export function GetAktResponseBaseTypeFromJSON(json: any): GetAktResponseBaseType {
    return GetAktResponseBaseTypeFromJSONTyped(json, false);
}

export function GetAktResponseBaseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseBaseType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function GetAktResponseBaseTypeToJSON(value?: GetAktResponseBaseType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'icon': value.icon,
        'id': value.id,
    };
}


